export const BACKEND_DOMAIN =
  process.env.NODE_ENV === "production"
    ? "https://avitaresidences.in/avita"
    : "http://localhost:8008";
// export const BACKEND_DOMAIN = 'https://avitaresidences.in/avita'
export const BACKEND_BASE = "/api/v1";
